import React from "react";
import { Navigate } from "react-router-dom";
import Cookies from "js-cookie";
import { isConsultantLoginReadinessPending } from "./util/deviceReadiness";

const FreeAuthRoute = ({ auth, children, title = "" }) => {
  const token = localStorage.getItem("auth_token") || Cookies.get("auth_token");

  if (token) {
    // Login stores the token before its async profile request finishes. During
    // that render, preserve the consultant readiness destination instead of
    // racing the login handler back to the public homepage.
    return (
      <Navigate
        to={isConsultantLoginReadinessPending() ? "/control-panel" : "/"}
        replace
      />
    );
  } else {
    return <>{children}</>;
  }
};

export default FreeAuthRoute;
